// extracted by mini-css-extract-plugin
export var labelWrapper = "_mg-0";